import $ from "jquery";
import jBox from "jbox";
import { useEffect, useState } from "react";

const ModalCancel = ({ isOpen = false, onClose, onCloseConfirm }) => {
  const [modalRef, setModalRef] = useState(null);

  useEffect(() => {
    if (modalRef && isOpen) {
      openModal();
      listenerConfirmModal();
      listenerCloseModal();
    }
  }, [modalRef, isOpen]);

  useEffect(() => {
    const initModalRef = new jBox("Modal", {
      closeButton: false,
      closeOnClick: false,
      minWidth: 325,
      maxWidth: 375,
      content: $("#ModalCancelEdit"),
    });
    setModalRef(initModalRef);

    return () => {
      initModalRef.destroy();
    };
  }, []);

  const listenerConfirmModal = () => {
    const btnCloseModal = document.getElementById("btnCloseModalCF");
    btnCloseModal.addEventListener("click", () => {
      onCloseConfirm();
    });
  };

  const listenerCloseModal = () => {
    const btnCloseModal = document.getElementById("btnCloseModalC");
    btnCloseModal.addEventListener("click", () => {
      closeModal();
    });
    const btnCloseModal2 = document.getElementById("btnCloseModalC2");
    btnCloseModal2.addEventListener("click", () => {
      closeModal();
    });
  };

  const openModal = () => {
    modalRef.open();
  };

  const closeModal = () => {
    modalRef.close();
    onClose();
  };

  return (
    <div
      className="bModal bCard"
      id="ModalCancelEdit"
      style={{ display: "none" }}
    >
      <div className="bInner">
        <div className="bDetails">
          <i className="icoAlert"></i>
          <p className="tTitle">ยกเลิกการแก้ไข</p>
          <p className="tDetails">
            หากคุณกดยกเลิก ข้อมูลที่แก้ไขทั้งหมดจะไม่ถูกบันทึก
            คุณยังยืนยันการยกเลิกอยู่ไหม?
          </p>
        </div>
        <div className="bBtn">
          <a className="btn red" id="btnCloseModalCF">
            ยืนยันการยกเลิก
          </a>
          <a className="btn outline red btnModalCancel" id="btnCloseModalC">
            ไม่ต้องการยกเลิก
          </a>
        </div>
        <a className="btnCloseModal2" id="btnCloseModalC2"></a>
      </div>
    </div>
  );
};

export default ModalCancel;
